// Card pequeno mostrando um KPI numérico (rótulo + valor colorido).
import { Card, Typography } from 'antd';

const { Text } = Typography;

interface Props {
  rotulo: string;
  valor: number;
  cor?: string;
}

export default function KpiCard({ rotulo, valor, cor = '#888' }: Props) {
  return (
    <Card size="small" bodyStyle={{ padding: 8 }} style={{ borderLeft: `3px solid ${cor}` }}>
      <Text type="secondary" style={{ fontSize: 9, textTransform: 'uppercase', letterSpacing: 0.4 }}>{rotulo}</Text>
      <div style={{ fontSize: 16, fontWeight: 600, color: cor }}>{valor}</div>
    </Card>
  );
}
